import { AnyAction } from "redux";

export const START_AUTH = "START_AUTH";
export const CHECK_AUTH_STATUS = "CHECK_AUTH_STATUS";

export const startAuthProcessAction = (
  integrationType: string,
  shopId: string,
  id?: number,
  additionalInfo?: unknown
): AnyAction => ({
  type: START_AUTH,
  integrationType,
  shopId,
  id,
  meta: {
    type: "api",
    url: `shop/${shopId}/auth/start`,
    method: "post",
    data: { additionalInfo, type: integrationType, id }
  }
});

export const checkStatusAction = (
  integrationType: string,
  shopId: string,
  token: string,
  id: number
): AnyAction => ({
  type: CHECK_AUTH_STATUS,
  integrationType,
  shopId,
  id,
  meta: {
    type: "api",
    url: `shop/${shopId}/auth/status/${token}`,
    method: "get"
  }
});
